import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import TrialOnboardingContentGql from '@/store/graphql/system/queries/TrialOnboardingContent.gql';
import SaveTrialOnboardingContentGql from '@/store/graphql/system/mutations/SaveTrialOnboardingContent.gql';

export default {
    fetch: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TrialOnboardingContentGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.TrialOnboardingContent))
                .catch(err => reject(err));
        }),
    save: input => {
        if (input === undefined) throw new Error('required argument is missing');

        input = _.removeDeepByKey(input, '__typename');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveTrialOnboardingContentGql,
                    variables: { input }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.SaveTrialOnboardingContent);
                })
                .catch(err => reject(err));
        });
    }
};
